__turbopack_context__.v({
  "cryptoLogoBox": "PaymentMethodsGrid-module__UDR7Zq__cryptoLogoBox",
  "linkedLogoBox": "PaymentMethodsGrid-module__UDR7Zq__linkedLogoBox",
  "logosContainer": "PaymentMethodsGrid-module__UDR7Zq__logosContainer",
  "paymentLogoBox": "PaymentMethodsGrid-module__UDR7Zq__paymentLogoBox",
});
